<app-landing-toolbar></app-landing-toolbar>
<div id="login-wrapper" class="primary-background-gradient">
    <mat-card>
        <h1>Login</h1>
        <form (ngSubmit)="onSubmit()" [formGroup]="loginForm">
            <mat-form-field class="full-width">
                <input #email formControlName="email" matInput placeholder="Email" type="email">
                <mat-error *ngIf="loginForm.controls.email.hasError('required')">You need to provide an email to
                    login!
                </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
                <input formControlName="password" matInput placeholder="Password" type="password">
                <mat-error *ngIf="loginForm.controls.password.hasError('required')">You need to provide a password to
                    login!
                </mat-error>
            </mat-form-field>
            <div id="login-button">
                <button [disabled]="!loginForm.valid" class="full-width" color="primary" mat-raised-button gtagEvent trackOn="click" action="login" category="accounts">
                    Login
                </button>
            </div>
            <div class="full-width" id="error">
                <mat-error *ngIf="error">{{ error }}</mat-error>
            </div>
        </form>
        <span class="reset">Forgot your password? <a class="accent" gtagEvent trackOn="click" action="forgot_password"
                                                     category="accounts"
                                                     routerLink="/request-reset">Reset Password</a></span>
    </mat-card>
</div>
